import React from "react";

function TableIndividu({title,underlying, nilaiPinjaman, bunga, biayaLayanan, tenor, pembayaranPokok, pembayaranBunga, jenisJaminan}){
    return (
        <div className="table-wrapper">
            <table className='table-individu'>
                <thead>
                    <tr>
                        <th><span>Ringkasan Produk&emsp;</span><div dangerouslySetInnerHTML={{__html: title}}/></th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td>Penerima Dana</td>
                        <td>{underlying}</td>
                    </tr>
                    <tr>
                        <td>Limit Pinjaman</td>
                        <td>{nilaiPinjaman}</td>
                    </tr>
                    <tr>
                        <td>Jangka Waktu Pinjaman</td>
                        <td>{tenor}</td>
                    </tr>
                    <tr>
                        <td>Bunga</td>
                        <td>{bunga}</td>
                    </tr>
                    <tr>
                        <td>Biaya-biaya</td>
                        <td><div dangerouslySetInnerHTML={{__html: biayaLayanan}}/></td>
                    </tr>
                    {title === 'Kredit Multiguna' && (
                    <tr>
                        <td>Jenis Jaminan</td>
                        <td>{jenisJaminan}</td>
                    </tr>
                    )}
                    <tr>
                        <td>Pembayaran Angsuran (pokok+bunga)</td>
                        <td>{pembayaranPokok}</td>
                    </tr>
                </tbody>
            </table>
        </div>
    );
}

function TableProduktif({title, penerimaDana, limit, jangkaFasilitas, jangkaPencairan, bunga, biayaLainnya, jenisJaminan, skemaPembayaran}){
    return (
        <div className="table-wrapper">
            <table className="table-produktif">
                <thead>
                <tr>
                    <th><span>Tipe Pinjaman&emsp;</span><div dangerouslySetInnerHTML={{__html: title}}/></th>
                </tr>
                </thead>
                <tbody>
                <tr>
                    <td>Penerima Dana</td>
                    <td>{penerimaDana}</td>
                </tr>
                <tr>
                    <td>Limit Pinjaman</td>
                    <td>{limit}</td>
                </tr>
                <tr>
                    <td>Jangka Waktu Fasilitas</td>
                    <td>{jangkaFasilitas}</td>
                </tr>
                {jangkaPencairan !== '' && (
                    <tr>
                        <td>Jangka Waktu Per Pencairan</td>
                        <td>{jangkaPencairan}</td>
                    </tr>
                )}
                <tr>
                    <td>Bunga</td>
                    <td>{bunga}</td>
                </tr>
                <tr>
                    <td>Biaya-biaya</td>
                    <td><div dangerouslySetInnerHTML={{__html: biayaLainnya}}/></td>
                </tr>
                <tr>
                    <td>Jenis Jaminan</td>
                    <td><div dangerouslySetInnerHTML={{__html: jenisJaminan}}/></td>
                </tr>
                <tr>
                    <td>Skema Pembayaran</td>
                    <td><em>{skemaPembayaran}</em></td>
                </tr>
                </tbody>
            </table>
        </div>
    );
}

export default function Table({type, title}) {
    return (
        <div className="container-alur">
            {type === 'individu'
                ? title === 'kasbon'
                    ? <TableIndividu
                        title='Kasbon <em>(Emergency Loan)</em>'
                        underlying='Slip Gaji'
                        nilaiPinjaman='Rp 1 - 2 Juta'
                        bunga='0%'
                        biayaLayanan='Rp 75.000'
                        tenor='1 bulan'
                        pembayaranPokok='Bulanan'
                        pembayaranBunga='Bulanan'
                    />
                    : title === 'kmg'
                        ? <TableIndividu
                            title='Kredit Multiguna'
                            underlying='Warga Negara Indonesia (WNI), berdomisili di Indonesia'
                            nilaiPinjaman='Maksimum s.d. 2 Milyar'
                            bunga='24% efektif per tahun'
                            biayaLayanan='Provisi (4%)<br/>
                            Biaya keterlambatan (0,2% per hari)<br/>
						    Biaya lainnya (Notaris/ Pengikatan Agunan/ Appraisal KJPP/ Asuransi (sesuai tagihan))'
                            tenor='Maksimum s.d. 5 tahun'
                            pembayaranPokok='Bulanan'
                            jenisJaminan='Tanah & Bangunan'
                        />
                        : <TableIndividu
                            title='<em>Employee Benefit Program</em>'
                            underlying='Warga Negara Indonesia (WNI), berdomisili di Indonesia'
                            nilaiPinjaman='Rp 3 - 30 juta'
                            bunga='2.19% flat perbulan'
                            biayaLayanan='Biaya keterlambatan (2% perbulan)<br/>Pelunasan dipercepat (7% dari sisa pokok)'
                            tenor='3 - 24 bulan'
                            pembayaranPokok='Bulanan'
                        />
                : title === "invoice"
                    ? <TableProduktif
                        title='<em>Invoice Financing</em>'
                        penerimaDana='Badan Usaha/ Badan Hukum, Individu Warga Negara Indonesia (WNI), berdomisili di Indonesia'
                        limit='Maksimum s.d. 5 Milyar'
                        jangkaFasilitas='1 (satu) tahun'
                        jangkaPencairan='Maksimum s.d. 6 bulan'
                        bunga='24% per tahun'
                        biayaLainnya='‣ Provisi (4,5%)<br/>‣ Administrasi (0,5%)<br/>‣ Biaya keterlambatan (maksimum 0,1% per hari)'
                        jenisJaminan='<em>Invoice</em>/faktur yang dibiayai, Cek Mundur, <em>Personal/ Corporate Guarantee</em>'
                        skemaPembayaran='Bullet payment'
                    />
                    : title === 'inventory'
                        ? <TableProduktif
                            title='<em>Inventory Financing</em>'
                            penerimaDana='Badan Usaha/ Badan Hukum, Individu Warga Negara Indonesia (WNI), berdomisili di Indonesia'
                            limit='Maksimum s.d. 5 Milyar'
                            jangkaFasilitas='1 (satu) tahun'
                            jangkaPencairan='Maksimum s.d. 3 bulan'
                            bunga='24% per tahun'
                            biayaLainnya='‣ Provisi (4,5%)<br/>‣ Administrasi (0,5%)<br/>‣ Biaya keterlambatan (maksimum 0,1% per hari)'
                            jenisJaminan='Persediaan <em>(stock), Personal/ Corporate Guarantee</em>'
                            skemaPembayaran='Balloon payment'
                        />
                        : <TableProduktif
                            title='<em>Developer Financing</em>'
                            penerimaDana='Badan Usaha/ Badan Hukum, Individu Warga Negara Indonesia (WNI), berdomisili di Indonesia'
                            limit='Maksimum s.d. 5 Milyar'
                            jangkaFasilitas='18 (delapan belas) bulan'
                            jangkaPencairan=''
                            bunga='24% per tahun'
                            biayaLainnya='‣ Provisi (4,5%)<br/>‣ Administrasi (0,5%)<br/>‣ Biaya keterlambatan (maksimum 0,1% per hari)'
                            jenisJaminan='Sertifikat SHM/ SHGB, Cek Mundur, <em>Personal/ Corporate Guarantee</em> '
                            skemaPembayaran='Monthly Installment'
                        />
            }
        </div>
    );
}